import $ from 'jquery';

var states = [
  'Мебель в стиле Ампир', 'Мебель в стиле Ампир', 'Мебель в стиле Ампир', 
  'Мебель в стиле Ампир', 'Мебель в стиле Ампир', 'Мебель в стиле Ампир',
  'Скифское золото', 'Скифское искусство', 'Скифы: Наследие', 'Скифский наконечник для стрел',
  'Скифская табличка для украшения пояса', 'Скифское царство', 'Скифская этника',
  'Скифские имена', 'Скипетр Ивана IV Грозного',
];

$(document).ready(function() {
	$(".js-autocomplete").autocomplete({
		minLength:3,
	    source:[states]
	});
});



// WEBPACK FOOTER //
// ./src/js/pages/materials/search-autocomplete.js